import { createMutation } from '../api/mutation'

export const useCreateDocument = createMutation({
    url: '/document',
    method: 'POST',
})

export const useUpdateDocument = createMutation({
    url: '/document',
    method: 'PATCH',
})

export const useCreateDocumentVersion = createMutation({
    url: '/document/create-version',
    method: 'POST',
})

export const useRestoreDocumentVersion = createMutation({
    url: '/document/restore-version',
    method: 'POST',
})

export const useDeleteDocument = createMutation({
    url: '/document',
    method: 'DELETE',
})

export const useToggleSoftDeleteDocument = createMutation({
    url: '/toggle-soft-delete',
    method: 'POST',
})

export const useBulkSoftDeleteDocument = createMutation({
    url: '/bulk-soft-delete',
    method: 'POST',
})

export const useBulkRestoreDocument = createMutation({
    url: '/bulk-restore',
    method: 'POST',
})

export const useDeleteDocuments = createMutation({
    url: '/documents',
    method: 'DELETE',
})

export const useDuplicateDocument = createMutation({
    url: '/duplicate',
    method: 'POST',
})

export const useSaveFileCopy = createMutation({
    url: '/save-file-copy',
    method: 'POST',
})

export const useMoveDocument = createMutation({
    url: '/move-document',
    method: 'POST',
})

export const useExportDocument = createMutation({
    url: '/export-document',
    method: 'POST',
    apiOptions: {
        responseType: 'blob',
    },
})

export const useBulkExport = createMutation<Blob>({
    url: '/bulk-export',
    method: 'POST',
    apiOptions: {
        responseType: 'blob',
    },
})

export const useUpdateDocumentPermissions = createMutation({
    url: '/document-permissions',
    method: 'PATCH',
})

export const useUploadDocuments = createMutation({
    url: '/upload-documents',
    method: 'POST',
    apiOptions: {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    },
})

export const useRemoveSelfDocumentAccess = createMutation({
    url: '/remove-self-document-access',
    method: 'POST',
})

export const useRequestDocumentAccess = createMutation({
    url: '/document/request-access',
    method: 'POST',
})

export const useProcessDocumentAccessRequest = createMutation({
    url: '/document/process-access-request',
    method: 'POST',
})
